import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  UpgradableNumber,
  WeaponLimitation,
  WeaponMasteryFeature,
} from "@dndModels";

import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
// import SelectStringBox from '../../../../components/input/selects/SelectStringBox';
import WeaponLimitInput from "@dndComponents/limitations/WeaponLimitInput";

interface Props { 
  obj: WeaponMasteryFeature;
  onChange: (changed: WeaponMasteryFeature) => void;
  disabled?: boolean;
  attached_table?: AttachedTable;
}

export default function WeaponMasteryFeatureInput({ 
  obj,
  onChange,
  disabled = false,
  attached_table
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [myObj, setMyObj] = useState(obj.clone());
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      {/* <Grid item xs={12}>
        <SelectStringBox 
          name="Improvement Type" 
          value={myObj.improvement_type} 
          options={["Change","Merge","None"]}
          disabled={disabled}
          onChange={(changed: string) => {
            const new_ff = myObj;
            (new_ff.improvement_type as string) = changed;
            setMyObj(new_ff);
            onChange(new_ff);
          }} 
        />
      </Grid> */}
      <Grid
        size={{
          xs: 12
        }}>
        <WeaponLimitInput
          obj={myObj.weapon_limit}
          disabled={disabled}
          onChange={(changed: WeaponLimitation) => {
            const new_obj = myObj;
            new_obj.weapon_limit = changed.clone();
            setMyObj(new_obj);
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <UpgradableNumberBox 
          name="Weapon Mastery Count" 
          value={myObj.count} 
          disabled={disabled}
          attached_table={attached_table}
          onChange={(changed: UpgradableNumber) => {
            const new_ff = myObj;
            new_ff.count = changed.clone();
            setMyObj(new_ff);
            onChange(new_ff);
          }} 
        />
      </Grid>
    </Grid>
  );
}
